import styled from 'styled-components';
import { mediaQuery } from '../../../utils';

export const StyledNavigationFlex = styled.div`
  width: 100%;
  margin-bottom: 3.5rem;

  ${mediaQuery('md')} {
    div:first-child {
      align-items: flex-end;
    }
  }
`;
